'use strict'

const documentTypes = {
  1: 'Verkaufsrechnung',
  2: 'Verkaufsgutschrift',
  3: 'Einkaufsrechnung',
  4: 'Einkaufsgutschrift',
}

export function documentTypeFilter() {
  return function (type) {
    return documentTypes[type]
  }
}



// WEBPACK FOOTER //
// ./app/documents/filters/document-type.filter.js